import PropTypes from 'prop-types';

import { useCurrentProjectId, useCurrentToolId } from '@adsk/alloy-provider';
import Theme from '@adsk/alloy-react-theme';

import { EntityMenuItem } from '@adsk/acc-reference-picker';
import Badge from '@adsk/alloy-react-badge';
import { StyledBadge } from '../../../components';
import { genDeepLinkUrl } from '../helpers/genDeepLinkUrl';
import { getStatusColor } from '../../../helpers';

const RfiEntityCellItem = ({ entity, ...rest }) => {
  const projectId = useCurrentProjectId();
  const currentToolId = useCurrentToolId();
  const { title, id, customIdentifier, status } = entity;
  const statusColor = getStatusColor(status);
  const url = genDeepLinkUrl({ projectId, rfiId: id, currentToolId });

  const label = (
    <StyledBadge color={statusColor} variant={Badge.VARIANTS.LINE}>
      {customIdentifier && customIdentifier !== '-' && (
        <span style={{ paddingLeft: 3 }}>{`#${customIdentifier}`}</span>
      )}
      <span style={{ paddingLeft: 3, color: Theme.colors.charcoal700 }}>{title}</span>
    </StyledBadge>
  );

  return <EntityMenuItem label={label} link={url} {...rest} />;
};

RfiEntityCellItem.propTypes = {
  /**
   * The RFI entity we need to render.
   */
  entity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    customIdentifier: PropTypes.string.isRequired,
  }).isRequired,
};
export default RfiEntityCellItem;
